import { DYNAMIC_TYPE_OPTIONS } from '../types/planning';

interface SelectedRelationshipDisplayProps {
  selectedValue: string;
  variant?: 'compact' | 'prominent' | 'nav';
}

export function SelectedRelationshipDisplay({
  selectedValue,
  variant = 'compact',
}: SelectedRelationshipDisplayProps) {
  if (!selectedValue) return null;

  const selectedOption = DYNAMIC_TYPE_OPTIONS.find((opt) => opt.value === selectedValue);
  if (!selectedOption) return null;

  if (variant === 'prominent') {
    // Used on Scene Dynamic page - larger, more prominent
    return (
      <div className="inline-flex items-center gap-3 px-5 py-2.5 rounded-lg bg-gradient-to-r from-slate-900/80 via-gray-900/90 to-slate-900/80 border-2 border-slate-700/60 shadow-lg shadow-black/40 animate-pulse-subtle">
        <span className="text-sm font-bold text-slate-400 uppercase tracking-wider">Selected:</span>
        <h3 className="text-lg font-bold bg-gradient-to-r from-red-400 via-red-500 to-red-700 bg-clip-text text-transparent">
          {selectedOption.label}
        </h3>
      </div>
    );
  }

  if (variant === 'nav') {
    // Subtle variant for the editor navbar
    return (
      <div className="inline-flex items-center px-3 py-1 rounded-md bg-[#0c1222] border border-[#1a2d4d] text-xs text-slate-300">
        <span className="mr-1 text-slate-400">Character Dynamic:</span>
        <span className="font-semibold">{selectedOption.label}</span>
      </div>
    );
  }

  // Compact variant for Scene Planning page
  return (
    <div className="mb-3">
      <span className="text-xs font-medium text-gray-400">Selected Relationship</span>
      <div className="mt-1 inline-flex items-center px-3 py-1.5 rounded-lg bg-gradient-to-r from-slate-900/80 via-gray-900/90 to-slate-900/80 border-2 border-slate-700/60 shadow-lg shadow-black/40">
        <h3 className="text-sm font-bold bg-gradient-to-r from-red-400 via-red-500 to-red-700 bg-clip-text text-transparent">
          {selectedOption.label}
        </h3>
      </div>
    </div>
  );
}
